module.exports = __webpack_public_path__ + "67ae6f64b23caec715c7b333f45a34fc.pdf";